// 新增states時要注意，若是網址是新的網址，要記得去改SEOPageServlet.java，不然重整會被踢到404
var STATES = {
    HOME: 'home', // 首頁
    SIGNUP: 'signup', // 註冊頁 (選擇註冊一般或企業的頁面)
    MEMBER_SIGNUP: 'member_signup', // 一般會員註冊頁
    ENTERPRISE_SIGNUP: 'enterprise_signup', // 企業用戶landing page 及 註冊頁

    ALL_PRODUCT: 'all_product', // 所有商品
    PRODUCT_LIST: 'product_list', // 商品列表
    PRODUCT: 'product', // 商品頁面
    COMPLEX_PDT: 'complex_pdt', // 複合商品

    CART: 'cart', // 購物車
    PAYMENT: 'payment', // 訂單頁面
    PAYMENT_CONFIRM: 'payment_confirm', // 結帳前確認頁
    PAYMENT_RESULT: 'payment_result', // 結帳結果畫面
    PAYMENT_SINOPACATM: 'payment_sinopacatm', // 永豐ATM結帳畫面
    PAYMENT_SINOPACCREDITCARD: 'payment_sinopaccreditcard', // 永豐信用卡結帳畫面
    PAYMENT_POINT: 'payment_point', // 預儲點數結帳畫面
    PAYMENT_OUTWARDREMITTANCE: 'payment_outwardremittance', // 金融機構臨櫃匯款畫面
    PAYMENT_SPGATEWAYCVS: 'payment_spgatewaycvs', // 智付通超商付款畫面
    PAYMENT_MONTHLY: 'payment_monthly', // 月結付款畫面

    EXTRAFEE: 'extrafee', // 補收款
    EXTRAFEE_PAYMENT_RESULT: 'extrafee_payment_result', // 補收款 結帳結果畫面
    EXTRAFEE_PAYMENT_SINOPACATM: 'extrafee_payment_sinopacatm', // 補收款 永豐ATM結帳畫面
    EXTRAFEE_PAYMENT_SINOPACCREDITCARD: 'extrafee_payment_sinopaccreditcard', // 補收款 永豐信用卡結帳畫面
    EXTRAFEE_PAYMENT_POINT: 'extrafee_payment_point', // 補收款 預儲點數結帳畫面
    EXTRAFEE_PAYMENT_OUTWARDREMITTANCE: 'extrafee_payment_outwardremittance', // 補收款 金融機構臨櫃匯款畫面
    EXTRAFEE_PAYMENT_SPGATEWAYCVS: 'extrafee_payment_spgatewaycvs', // 補收款 智付通超商付款畫面
    EXTRAFEE_PAYMENT_MONTHLY: 'extrafee_payment_monthly', // 補收款 月結付款畫面

    MEMBER: 'member', // 會員相關頁面
    MEMBER_ORDER_LIST: 'member.orderlist', // 我的訂單
    MEMBER_ORDER_LIST_ALL: 'member.orderlist.all', // 我的訂單（所有
    MEMBER_ORDER_LIST_PAY: 'member.orderlist.pay', // 我的訂單（待付款
    MEMBER_ORDER_LIST_DISCARD: 'member.orderlist.discard', // 我的訂單（作廢
    MEMBER_ORDER_LIST_SUCCESS: 'member.orderlist.success', // 我的訂單（完成
    MEMBER_ORDER_HISTORY: 'member.orderhistory', // 訂購紀錄
    MEMBER_PROFILE: 'member.profile', // 個人資料
    MEMBER_CHANGE_PWD: 'member.change_pwd', // 更改密碼
    MEMBER_FAVORITE_ADDRESS: 'member.favorite_address', // 常用地址
    MEMBER_SYSTEM_MESSAGE: 'member.system_message', // 系統消息
    MEMBER_POINTS: 'member.points', // 現金點數記錄
    MEMBER_POINTS_CONSUMELOG: 'member.points.consumelog', // 點數使用記錄
    MEMBER_POINTS_STORE: 'member.points.store', // 現金點數加值
    MEMBER_POINTS_STORELOG: 'member.points.storelog', // 點數加值記錄
    MEMBER_POINTS_MONTHLY_PAYMENT: 'member.points.monthly_payment', // 月結點數繳款
    MEMBER_POINTS_MONTHLY_PAYMENTLOG: 'member.points.monthly_paymentlog', // 點數繳款記錄列表
    MEMBER_POINTS_MONTHLY_PAYMENTLOG_INFO: 'member.points.monthly_paymentlog_info', // 點數繳款記錄
    MEMBER_POINTS_PAYMENT: 'member.points.payment', // 現金點數付款頁
    MEMBER_POINTS_PAYMENT_RESULT: 'member.points.payment_result', // 現金點數付款結果頁
    MEMBER_POINTS_PAYMENT_SINOPACATM: 'member.points.payment_sinopacatm', // 現金點數 永豐ATM結帳畫面
    MEMBER_POINTS_PAYMENT_SINOPACCREDITCARD: 'member.points.payment_sinopaccreditcard', // 現金點數 永豐信用卡結帳畫面
    MEMBER_POINTS_PAYMENT_OUTWARDREMITTANCE: 'member.points.payment_outwardremittance', // 現金點數 金融機構臨櫃匯款畫面
    MEMBER_POINTS_PAYMENT_SPGATEWAYCVS: 'member.points.payment_spgatewaycvs', // 智付通超商付款畫面

    MEMBER_BONUSPOINTS: 'member.bonuspoints', // 紅利點數記錄
    MEMBER_ORDER_TEMPLATE: 'member.order_template', // 快速下單 模板列表
    MEMBER_SPECIAL_OFFER_LIST: 'member.special_offer_list', // 報價單列表
    MEMBER_SPECIAL_OFFER_INFO: 'member.special_offer_info', // 報價資訊

    ABOUT: 'about', // 關於inif印衣服

    FAQ: 'faq',
    FAQ_LIST: 'faq.list',

    SEARCH: 'search', //搜尋
    SEARCH_PDT: 'search.pdt',  // 搜尋產品
    SEARCH_FAQ: 'search.faq', // 搜尋 FAQ

    // SPECIAL_OFFER: 'special_offer', // 專人報價頁面
    POINTS_INTRODUCTION: 'points_introduction', // 點數加值landing page
    POINTS_MONTHLY_INTRODUCTION: 'points_monthly_introduction', // 月節landing page

    REGISTER_SUCCESS: 'register_success', // 註冊完成頁面
    MAIL_IDENTIFY: 'mail_identify', // Email 認證頁
    BUSINESSMEMBER_MAIL_IDENTIFY: 'businessmember_mail_identify', // 企業用戶 Email 認證頁
    RESET_PASSWORD: 'reset_password', // 重設密碼頁面
    RESET_BUSINESS_MEMBER_PASSWORD: 'reset_business_member_password', // 重設企業用戶密碼頁面
    CHANGE_EMAIL: 'changeemail', // 更換Email頁面
    ACTIVITY_CHECK: 'activitycheck', // 活動檢查頁面
    ACTIVITY_CHECK_WITH_DATE: 'activitycheck_with_date', // 活動檢查頁面

    // CMS 相關
    BLOG_LIST: 'blog_list',
    BLOG_POST: 'blog_post',
    RESOURCE_LIST: 'resource_list',
    DESIGN: 'design',
    DESIGNER_LIST: 'design.designer_list',
    PROJECT_LIST: 'design.project_list',
    PROJECT_POST: 'project_post',
    DESIGNER: 'designer',
};

// 明確發布 route state 常數給 downstream scripts 讀取。
// 舊 build 靠 concat 後的共用 function scope 直接看到裸 STATES；改用 bundler 後每支檔案各自是
// module scope，跨檔案的裸 STATES 會失效，因此改由 window 契約供應。
window.STATES = STATES;

var TIMESTAMP = $('#update-time').attr('update-time');

// 同上理由：js/directives/cupoy_image.js 以裸 TIMESTAMP 讀這個值做快取破壞。
// （那支檔 mobile 也載入，但 mobile/js/mobileapp.js 沒有宣告 TIMESTAMP ——
//   在 mobile 上它現在就是 undefined，本次不改變這個既有行為。）
window.TIMESTAMP = TIMESTAMP;

var app = angular.module('InifECApp', [
    'InifECShared', // 跨 module 共用檔的註冊目標，見 js/shared.js
    'ui.router',
    'ngStorage',
    'facebook',
    'facebook.config',
    'ngFileUpload',
    'ngEnter',
    'infinite-scroll',
    'ngScrollbar',
    'ct.ui.router.extras',
    'ngCookies',
    'ngModal',
    'ngDropdown',
    'angucomplete',
    'Notifications',
    'angulartics', // for analytics
    'angulartics.google.analytics', // for google analytics,
    'oc.lazyLoad',
    'cupoy.draft',
])

.config(['$sceProvider', '$stateProvider', '$urlRouterProvider', '$locationProvider', '$animateProvider', '$stickyStateProvider',
    function($sceProvider, $stateProvider, $urlRouterProvider, $locationProvider, $animateProvider, $stickyStateProvider) {
        
        // 移除angular的#符號，使用restURL呈現，需要搭配後端支援，後端部分請查看 SEOPageFilter
        $locationProvider.html5Mode(true);
        // 取消ng-animate功能，若是有ng-animate的class name才會有ng-animate的效果
        $animateProvider.classNameFilter(/angular-animate/);
        // ng-bind-html word
        $sceProvider.enabled(false);
        // Start Page
        $urlRouterProvider.otherwise("/");

        $stickyStateProvider.enableDebug(false);

        // ui view setting
        $stateProvider

        .state(STATES.HOME, {
            url: "/",
            views: {
                'home@': {
                    templateUrl: "partials/home.html",
                    controller: 'HomeController',
                }
            },
            deepStateRedirect: true,
            sticky: true,
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/home.js?t="+TIMESTAMP);
                }]
            }
        })

        // .state(STATES.SIGNUP, {
        //     url: "/signup",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/signup.html",
        //             controller: 'SignupController',
        //         },
        //     },
        //     deepStateRedirect: true,
        //     sticky: true,
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/signup.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        .state(STATES.MEMBER_SIGNUP, {
            url: "/member-signup",
            views: {
                'other@': {
                    templateUrl: "partials/member_signup.html",
                    controller: 'MemberSignupController',
                },
            },
            deepStateRedirect: true,
            sticky: true,
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/member_signup.js?t="+TIMESTAMP);
                }]
            },
        })

        // .state(STATES.ENTERPRISE_SIGNUP, {
        //     url: "/enterprise-signup?step",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/enterprise_signup.html",
        //             controller: 'EnterpriseSignupController',
        //         },
        //     },
        //     deepStateRedirect: true,
        //     sticky: true,
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/enterprise_signup.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        .state(STATES.ALL_PRODUCT, {
            url: "/all?mainPdtClass",
            views: {
                'all_product@': {
                    templateUrl: "partials/all_product.html",
                    controller: 'AllProductController',
                },
            },
            deepStateRedirect: true,
            sticky: true,
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                    // you can lazy load files for an existing module
                    return $ocLazyLoad.load("js/controllers/all_product.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PRODUCT_LIST, {
            url: "/class/:class",
            views: {
                'all_product@': {
                    templateUrl: "partials/all_product.html",
                    controller: 'AllProductController',
                },
            },
            deepStateRedirect: true,
            sticky: true,
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/all_product.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PRODUCT, {
            url: "/product/:productid",
            views: {
                'product@': {
                    templateUrl: "partials/product.html",
                    controller: 'ProductController',
                }
            },
            params: {
                'spec': '',
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/product.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.COMPLEX_PDT, {
            url: "/complexpdt/:complexid/:productid",
            views: {
                'product@': {
                    templateUrl: "partials/complex_pdt.html",
                    controller: 'ComplexPdtController',
                }
            },
            params: {
                'spec': '',
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/complex_pdt.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.CART, {
            url: "/cart",
            views: {
                'cart@': {
                    templateUrl: "partials/cart.html",
                    controller: 'CartController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/cart.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PAYMENT, {
            url: "/payment/:orderid",
            views: {
                'payment@': {
                    templateUrl: "partials/payment.html",
                    controller: 'PaymentController',
                }
            },
            params: {
                'anchor': '',
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PAYMENT_CONFIRM, {
            url: "/payment-confirm/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_confirm.html",
                    controller: 'PaymentConfirmController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_confirm.js?t="+TIMESTAMP);
                }]
            },
        })   

        .state(STATES.PAYMENT_RESULT, {
            url: "/payment-result/:orderid/:errorcode/:errordesc",
            views: {
                'other@': {
                    templateUrl: "partials/payment_result.html",
                    controller: 'PaymentResultController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_result.js?t="+TIMESTAMP);
                }]
            },
        })   

        .state(STATES.PAYMENT_SINOPACATM, {
            url: "/payment-sinopacatm/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_sinopacatm.html",
                    controller: 'PaymentSinopacATMController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_sinopacatm.js?t="+TIMESTAMP);
                }]
            },
        })  

        .state(STATES.PAYMENT_SINOPACCREDITCARD, {
            url: "/payment-sinopaccreditcard/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_sinopaccreditcard.html",
                    controller: 'PaymentSinopacCreditCardController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_sinopaccreditcard.js?t="+TIMESTAMP);
                }]
            },
        }) 

        .state(STATES.PAYMENT_POINT, {
            url: "/payment-point/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_point.html",
                    controller: 'PaymentPointController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_point.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PAYMENT_OUTWARDREMITTANCE, {
            url: "/payment-outwardremittance/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_outwardremittance.html",
                    controller: 'PaymentOutwardRemittanceController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_outwardremittance.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PAYMENT_SPGATEWAYCVS, {
            url: "/payment-spgatewaycvs/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_spgatewaycvs.html",
                    controller: 'PaymentSpgatewayCvsController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_spgatewaycvs.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.PAYMENT_MONTHLY, {
            url: "/payment-monthly/:orderid",
            views: {
                'other@': {
                    templateUrl: "partials/payment_monthly.html",
                    controller: 'PaymentMonthlyController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/payment_monthly.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.EXTRAFEE, {
            url: "/extrafee/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee.html",
                    controller: 'ExtrafeeController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.EXTRAFEE_PAYMENT_RESULT, {
            url: "/extrafee-payment-result/:extrafeeid/:errorcode/:errordesc",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_result.html",
                    controller: 'ExtrafeePaymentResultController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_result.js?t="+TIMESTAMP);
                }]
            },
        })   

        .state(STATES.EXTRAFEE_PAYMENT_SINOPACATM, {
            url: "/extrafee-payment-sinopacatm/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_sinopacatm.html",
                    controller: 'ExtrafeePaymentSinopacATMController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_sinopacatm.js?t="+TIMESTAMP);
                }]
            },
        })  

        .state(STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD, {
            url: "/extrafee-payment-sinopaccreditcard/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_sinopaccreditcard.html",
                    controller: 'ExtrafeePaymentSinopacCreditCardController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_sinopaccreditcard.js?t="+TIMESTAMP);
                }]
            },
        }) 

        .state(STATES.EXTRAFEE_PAYMENT_POINT, {
            url: "/extrafee-payment-point/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_point.html",
                    controller: 'ExtrafeePaymentPointController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_point.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE, {
            url: "/extrafee-payment-outwardremittance/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_outwardremittance.html",
                    controller: 'ExtrafeePaymentOutwardRemittanceController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_outwardremittance.js?t="+TIMESTAMP);
                }]
            },
        })

        // 補收款 智付通超商付款畫面
        .state(STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS, {
            url: "/extrafee-payment-spgatewaycvs/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_spgatewaycvs.html",
                    controller: 'ExtrafeePaymentSpgatewaycvsCvsResultController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_spgatewaycvs.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.EXTRAFEE_PAYMENT_MONTHLY, {
            url: "/extrafee-payment-monthly/:extrafeeid?orderid",
            views: {
                'other@': {
                    templateUrl: "partials/extrafee_payment_monthly.html",
                    controller: 'ExtrafeePaymentMonthlyController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/extrafee_payment_monthly.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.MEMBER, {
            url: "/member",
            views: {
                'member@': {
                    templateUrl: "partials/member.html",
                    controller: 'MemberController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/member.js?t="+TIMESTAMP);
                }]
            },
        })

            .state(STATES.MEMBER_ORDER_LIST, {
                url: "/orderlist",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/order_list.html",
                        controller: 'OrderListController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/order_list.js?t="+TIMESTAMP);
                    }]
                },
            })
                .state(STATES.MEMBER_ORDER_LIST_ALL, {
                    url: "/all",
                    views: {
                        'orderlist@member.orderlist': {
                            templateUrl: "partials/order_list_content.html",
                            controller: 'OrderListAllController',
                        }
                    },
                    resolve: {
                        loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                          // you can lazy load files for an existing module
                          return $ocLazyLoad.load("js/controllers/order_list_all.js?t="+TIMESTAMP);
                        }]
                    },
                })
                .state(STATES.MEMBER_ORDER_LIST_PAY, {
                    url: "/pay",
                    views: {
                        'orderlist@member.orderlist': {
                            templateUrl: "partials/order_list_content.html",
                            controller: 'OrderListPayController',
                        }
                    },
                    resolve: {
                        loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                          // you can lazy load files for an existing module
                          return $ocLazyLoad.load("js/controllers/order_list_pay.js?t="+TIMESTAMP);
                        }]
                    },
                })
                .state(STATES.MEMBER_ORDER_LIST_DISCARD, {
                    url: "/discard",
                    views: {
                        'orderlist@member.orderlist': {
                            templateUrl: "partials/order_list_content.html",
                            controller: 'OrderListDiscardController',
                        }
                    },
                    resolve: {
                        loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                          // you can lazy load files for an existing module
                          return $ocLazyLoad.load("js/controllers/order_list_discard.js?t="+TIMESTAMP);
                        }]
                    },
                })
                .state(STATES.MEMBER_ORDER_LIST_SUCCESS, {
                    url: "/success",
                    views: {
                        'orderlist@member.orderlist': {
                            templateUrl: "partials/order_list_content.html",
                            controller: 'OrderListSuccessController',
                        }
                    },
                    resolve: {
                        loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                          // you can lazy load files for an existing module
                          return $ocLazyLoad.load("js/controllers/order_list_success.js?t="+TIMESTAMP);
                        }]
                    },
                })

            .state(STATES.MEMBER_ORDER_HISTORY, {
                url: "/order/history",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/order_history.html",
                        controller: 'OrderHistoryController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/order_history.js?t="+TIMESTAMP);
                    }]
                },
            })

            .state(STATES.MEMBER_PROFILE, {
                url: "/profile",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/profile.html",
                        controller: 'ProfileController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/profile.js?t="+TIMESTAMP);
                    }]
                },
            })

            .state(STATES.MEMBER_CHANGE_PWD, {
                url: "/change-pwd",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/change_pwd.html",
                        controller: 'ChangePwdController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/change_pwd.js?t="+TIMESTAMP);
                    }]
                },
            })

            .state(STATES.MEMBER_FAVORITE_ADDRESS, {
                url: "/favorite-address",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/favorite_address.html",
                        controller: 'FavoriteAddressController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/favorite_address.js?t="+TIMESTAMP);
                    }]
                },
            })

            .state(STATES.MEMBER_SYSTEM_MESSAGE, {
                url: "/system-message",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/system_message.html",
                        controller: 'SystemMessageController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/system_message.js?t="+TIMESTAMP);
                    }]
                },
            })

            // .state(STATES.MEMBER_POINTS, {
            //     url: "/points",
            //     views: {
            //         'subcontent@member': {
            //             templateUrl: "partials/points.html",
            //             controller: 'PointsController',
            //         }
            //     },
            //     resolve: {
            //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //           // you can lazy load files for an existing module
            //           return $ocLazyLoad.load("js/controllers/points.js?t="+TIMESTAMP);
            //         }]
            //     },
            // })

            //     .state(STATES.MEMBER_POINTS_CONSUMELOG, {
            //         url: "/consumelog",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_consumelog.html",
            //                 controller: 'PointsConsumelogController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_consumelog.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            //     .state(STATES.MEMBER_POINTS_STORE, {
            //         url: "/store",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_store.html",
            //                 controller: 'PointsStoreController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_store.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            //     .state(STATES.MEMBER_POINTS_STORELOG, {
            //         url: "/storelog",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_storelog.html",
            //                 controller: 'PointsStorelogController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_storelog.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            //     .state(STATES.MEMBER_POINTS_MONTHLY_PAYMENT, {
            //         url: "/monthly-payment",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_monthly_payment.html",
            //                 controller: 'PointsMonthlyPaymentController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_monthly_payment.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            //     .state(STATES.MEMBER_POINTS_MONTHLY_PAYMENTLOG, {
            //         url: "/monthly-paymentlog",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_monthly_paymentlog.html",
            //                 controller: 'PointsMonthlyPaymentlogController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_monthly_paymentlog.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            //     .state(STATES.MEMBER_POINTS_MONTHLY_PAYMENTLOG_INFO, {
            //         url: "/monthly-paymentlog-info/:monthlypaymentid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_monthly_paymentlog_info.html",
            //                 controller: 'PointsMonthlyPaymentlogInfoController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_monthly_paymentlog_info.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     // .state(STATES.MEMBER_POINTS_CREATE, {
            //     //     url: "/create",
            //     //     views: {
            //     //         'pointslist@member.points': {
            //     //             templateUrl: "partials/pointsstore_create.html",
            //     //             controller: 'PointsStoreCreateController',
            //     //         }
            //     //     },
            //     //     resolve: {
            //     //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //     //           // you can lazy load files for an existing module
            //     //           return $ocLazyLoad.load("js/controllers/pointsstore_create.js?t="+TIMESTAMP);
            //     //         }]
            //     //     },
            //     // })
            //     .state(STATES.MEMBER_POINTS_PAYMENT, {
            //         url: "/payment/:pointsstoreid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment.html",
            //                 controller: 'PointsPaymentController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     .state(STATES.MEMBER_POINTS_PAYMENT_RESULT, {
            //         url: "/payment-result/:pointsstoreid/:errorcode/:errordesc",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment_result.html",
            //                 controller: 'PointsPaymentResultController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment_result.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     .state(STATES.MEMBER_POINTS_PAYMENT_SINOPACATM, {
            //         url: "/payment-sinopacatm/:pointsstoreid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment_sinopacatm.html",
            //                 controller: 'PointsPaymentSinopacATMController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment_sinopacatm.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     .state(STATES.MEMBER_POINTS_PAYMENT_SINOPACCREDITCARD, {
            //         url: "/payment-sinopaccreditcard/:pointsstoreid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment_sinopaccreditcard.html",
            //                 controller: 'PointsPaymentSinopacCreditCardController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment_sinopaccreditcard.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     .state(STATES.MEMBER_POINTS_PAYMENT_OUTWARDREMITTANCE, {
            //         url: "/payment-outwardremittance/:pointsstoreid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment_outwardremittance.html",
            //                 controller: 'PointsPaymentOutwardremittanceController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment_outwardremittance.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })
            //     .state(STATES.MEMBER_POINTS_PAYMENT_SPGATEWAYCVS, {
            //         url: "/payment-spgatewaycvs/:pointsstoreid",
            //         views: {
            //             'pointslist@member.points': {
            //                 templateUrl: "partials/points_payment_spgatewaycvs.html",
            //                 controller: 'PointsPaymentSpgatewaycvsCvsResultController',
            //             }
            //         },
            //         resolve: {
            //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //               // you can lazy load files for an existing module
            //               return $ocLazyLoad.load("js/controllers/points_payment_spgatewaycvs.js?t="+TIMESTAMP);
            //             }]
            //         },
            //     })

            // .state(STATES.MEMBER_BONUSPOINTS, {
            //     url: "/bonuspoints",
            //     views: {
            //         'subcontent@member': {
            //             templateUrl: "partials/bonuspoints.html",
            //             controller: 'BonusPointsController',
            //         }
            //     },
            //     resolve: {
            //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //           // you can lazy load files for an existing module
            //           return $ocLazyLoad.load("js/controllers/bonuspoints.js?t="+TIMESTAMP);
            //         }]
            //     },
            // })

            // .state(STATES.MEMBER_ORDER_TEMPLATE, {
            //     url: "/order_template",
            //     views: {
            //         'subcontent@member': {
            //             templateUrl: "partials/order_template.html",
            //             controller: 'OrderTemplateController',
            //         }
            //     },
            //     resolve: {
            //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //           // you can lazy load files for an existing module
            //           return $ocLazyLoad.load("js/controllers/order_template.js?t="+TIMESTAMP);
            //         }]
            //     },
            // })

            .state(STATES.MEMBER_SPECIAL_OFFER_LIST, {
                url: "/specialoffer-list",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/special_offer_list.html",
                        controller: 'SpecialOfferListController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/special_offer_list.js?t="+TIMESTAMP);
                    }]
                },
            })

            .state(STATES.MEMBER_SPECIAL_OFFER_INFO, {
                url: "/specialoffer/:specialofferid",
                views: {
                    'subcontent@member': {
                        templateUrl: "partials/special_offer_info.html",
                        controller: 'SpecialOfferInfoController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/special_offer_info.js?t="+TIMESTAMP);
                    }]
                },
            })

        .state(STATES.ABOUT, {
            url: "/about",
            views: {
                'other@': {
                    templateUrl: "partials/about.html",
                    controller: 'AboutController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/about.js?t="+TIMESTAMP);
                }]
            },
        })

        .state(STATES.FAQ, {
            url: "/faq",
            views: {
                'faq@': {
                    templateUrl: "partials/faq.html",
                    controller: 'FAQController',
                }
            },

            deepStateRedirect: true,
            sticky: true,
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/faq.js?t="+TIMESTAMP);
                }]
            },
        })
           
            .state(STATES.FAQ_LIST, {
                url: "/:mainfaqid/:subfaqid",
                views: {
                    'subcontent@faq': {
                        templateUrl: "partials/faq_list.html",
                        controller: 'FAQListController',
                    }
                },
                params: {
                    'faqid': '',
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/faq_list.js?t="+TIMESTAMP);
                    }]
                },
            })

        .state(STATES.SEARCH, {
            url: "/search",
            views: {
                'search@': {
                    templateUrl: "partials/search.html",
                    controller: 'SearchController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                    // you can lazy load files for an existing module
                    return $ocLazyLoad.load("js/controllers/search.js?t="+TIMESTAMP);
                }]
            },
        })

            .state(STATES.SEARCH_PDT, {
                url: "/pdt?keyword",
                views: {
                    'subcontent@search': {
                        templateUrl: "partials/search_pdt.html",
                        controller: 'SearchProductController',
                    }
                },
                resolve: {
                    loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                      // you can lazy load files for an existing module
                      return $ocLazyLoad.load("js/controllers/search_product.js?t="+TIMESTAMP);
                    }]
                },
            })
            // .state(STATES.SEARCH_FAQ, {
            //     url: "/faq?keyword",
            //     views: {
            //         'subcontent@search': {
            //             templateUrl: "partials/search_faq.html",
            //             controller: 'SearchFAQController',
            //         }
            //     },
            //     resolve: {
            //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
            //           // you can lazy load files for an existing module
            //           return $ocLazyLoad.load("js/controllers/search_faq.js?t="+TIMESTAMP);
            //         }]
            //     },
            // })


        // .state(STATES.SPECIAL_OFFER, {
        //     url: "/specialoffer",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/special_offer.html",
        //             controller: 'SpecialOfferController',
        //         }
        //     },
        //     params: {
        //         'pdtClass': '',
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //             // you can lazy load files for an existing module
        //             return $ocLazyLoad.load("js/controllers/special_offer.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // .state(STATES.POINTS_MONTHLY_INTRODUCTION, {
        //     url: "/points-monthly-introduction",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/points_monthly_introduction.html",
        //         },
        //     },
        // })

        // .state(STATES.POINTS_INTRODUCTION, {
        //     url: "/points-introduction",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/points_introduction.html",
        //         },
        //     },
        // })

        // .state(STATES.BLOG_LIST, {
        //     url: "/design/blog-list?category&sort&page",
        //     views: {
        //         'blog@': {
        //             templateUrl: "partials/cms_blog_list.html",
        //             controller: 'CMSBlogListController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_blog_list.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // .state(STATES.BLOG_POST, {
        //     url: "/blog-post/:slug",
        //     views: {
        //         'blog@': {
        //             templateUrl: "partials/cms_blog_post.html",
        //             controller: 'CMSBlogPostController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_blog_post.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // .state(STATES.RESOURCE_LIST, {
        //     url: "/design/resource-list?category&sort&page",
        //     views: {
        //         'resource@': {
        //             templateUrl: "partials/cms_resource_list.html",
        //             controller: 'CMSResuorceListController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_resource_list.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // .state(STATES.DESIGN, {
        //     url: "/design",
        //     views: {
        //         'design@': {
        //             templateUrl: "partials/cms_designer_project_post.html",
        //             controller: 'CMSDesignerProjectPostController',
        //         }
        //     },
        //     deepStateRedirect: true,
        //     sticky: true,
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_designer_project_post.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        //     .state(STATES.DESIGNER_LIST, {
        //         url: "/designer-list?category&sort&page",
        //         views: {
        //             'content@design': {
        //                 templateUrl: "partials/cms_designer_list.html",
        //                 controller: 'CMSDesignerListController',
        //             }
        //         },
        //         resolve: {
        //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //               // you can lazy load files for an existing module
        //               return $ocLazyLoad.load("js/controllers/cms_designer_list.js?t="+TIMESTAMP);
        //             }]
        //         },
        //     })

        //     .state(STATES.PROJECT_LIST, {
        //         url: "/project-list?category&sort&page",
        //         views: {
        //             'content@design': {
        //                 templateUrl: "partials/cms_project_list.html",
        //                 controller: 'CMSProjectListController',
        //             }
        //         },
        //         resolve: {
        //             loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //               // you can lazy load files for an existing module
        //               return $ocLazyLoad.load("js/controllers/cms_project_list.js?t="+TIMESTAMP);
        //             }]
        //         },
        //     })

        // .state(STATES.PROJECT_POST, {
        //     url: "/project-post/:slug",
        //     views: {
        //         'design@': {
        //             templateUrl: "partials/cms_project_post.html",
        //             controller: 'CMSProjectPostController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_project_post.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // .state(STATES.DESIGNER, {
        //     url: "/designer/:slug?page",
        //     views: {
        //         'design@': {
        //             templateUrl: "partials/cms_designer.html",
        //             controller: 'CMSDesignerController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/cms_designer.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // 註冊完成頁面
        .state(STATES.REGISTER_SUCCESS, {
            url: "/register-success/:email/success",
            views: {
                'other@': {
                    templateUrl: "partials/register_success.html",  
                    controller: 'RegisterSuccessController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/register_success.js?t="+TIMESTAMP);
                }]
            },
        })
        // 重設密碼
        .state(STATES.RESET_PASSWORD,{
            url: "/resetpasswd/:email/:token",
            views: {
                'other@': {
                    templateUrl: "partials/home.html",
                    controller: 'ResetPasswordController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/resetpassword.js?t="+TIMESTAMP);
                }]
            },
        })
        // // 重設企業用戶密碼頁面
        // .state(STATES.RESET_BUSINESS_MEMBER_PASSWORD,{
        //     url: "/resetbmpasswd/:email/:token",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/home.html",
        //             controller: 'ResetBusinessMemberPasswordController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/reset_business_member_password.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })

        // Email 認證頁
        .state(STATES.MAIL_IDENTIFY,{
            url: "/invitationMail/:token",
            views: {
                'other@': {
                    templateUrl: "partials/home.html",
                    controller: 'MailIdentifyController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/mailidentify.js?t="+TIMESTAMP);
                }]
            },
        })
        // Email 認證頁
        .state(STATES.CHANGE_EMAIL, {
            url: "/changeemail/:mrscid/:token",
            views: {
                'other@': {
                    templateUrl: "partials/home.html",
                    controller: 'ChangeEmailController',
                }
            },
            resolve: {
                loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
                  // you can lazy load files for an existing module
                  return $ocLazyLoad.load("js/controllers/changeemail.js?t="+TIMESTAMP);
                }]
            },
        })
        // // 企業用戶 Email 認證頁
        // .state(STATES.BUSINESSMEMBER_MAIL_IDENTIFY,{
        //     url: "/busi-invitation-mail/:token",
        //     views: {
        //         'other@': {
        //             templateUrl: "partials/home.html",
        //             controller: 'BusinessMemberMailIdentifyController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/business_member_mailidentify.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })
        // // 活動檢查頁面
        // .state(STATES.ACTIVITY_CHECK_WITH_DATE, {
        //     url: "/activitycheck/:date",
        //     views: {
        //         'other@': {
        //             // templateUrl: "partials/home.html",
        //             controller: 'ActivityCheckController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/activitycheck.js?t="+TIMESTAMP);
        //         }]
        //     },
        // })
        // // 活動檢查頁面
        // .state(STATES.ACTIVITY_CHECK, {
        //     url: "/activitycheck",
        //     views: {
        //         'other@': {
        //             // templateUrl: "partials/home.html",
        //             controller: 'ActivityCheckController',
        //         }
        //     },
        //     resolve: {
        //         loadCtrl:  ['$ocLazyLoad', function($ocLazyLoad) {
        //           // you can lazy load files for an existing module
        //           return $ocLazyLoad.load("js/controllers/activitycheck.js?t="+TIMESTAMP);
        //         }]
        //     },
        // });
    }
])

// google analytics Config
.config(['$analyticsProvider',
    function ($analyticsProvider) {

        // $analyticsProvider.virtualPageviews(false);

    }
])

.controller("RootController", ['$scope', '$state', '$timeout', '$rootScope', '$window', '$InifECGA', '$WebTitle', '$stateParams',
	function($scope, $state, $timeout, $rootScope, $window, $InifECGA, $WebTitle, $stateParams) {

        var isHomeView = function() {
            return $state.includes(STATES.HOME);
        }

        var isAllPdtView = function() {
            return $state.includes(STATES.ALL_PRODUCT) || $state.includes(STATES.PRODUCT_LIST);
        }

        var isProductView = function() {

            switch($rootScope.state){
                case STATES.PRODUCT:
                case STATES.COMPLEX_PDT:
                    return true;
                default:
                    return false;
            }
        }
        
        var isCartView = function() {
            return $state.includes(STATES.CART);
        }

        var isPaymentView = function() {
            return $state.includes(STATES.PAYMENT);
        }

        var isMemberView = function() {
            return $state.includes(STATES.MEMBER);
        }

        var isFaqView = function() {
            return $state.includes(STATES.FAQ);
        }

        var isSearchView = function() {
            return $state.includes(STATES.SEARCH);
        }

        var isBlogView = function() {

            switch($rootScope.state){
                case STATES.BLOG_LIST:
                case STATES.BLOG_POST:
                    return true;
                default:
                    return false;
            }
        }

        var isResourceView = function() {

            switch($rootScope.state){
                case STATES.RESOURCE_LIST:
                    return true;
                default:
                    return false;
            }
        }

        var isDesignView = function() {

            switch($rootScope.state){
                case STATES.DESIGN:
                case STATES.DESIGNER_LIST:
                case STATES.PROJECT_LIST:
                case STATES.PROJECT_POST:
                case STATES.DESIGNER:
                    return true;
                default:
                    return false;
            }
        }

        var isOtherView = function() {

            switch($rootScope.state){
                case STATES.PAYMENT_CONFIRM:
                case STATES.PAYMENT_RESULT:
                case STATES.PAYMENT_SINOPACATM:
                case STATES.PAYMENT_SINOPACCREDITCARD:
                case STATES.PAYMENT_POINT:
                case STATES.PAYMENT_OUTWARDREMITTANCE:
                case STATES.PAYMENT_SPGATEWAYCVS:
                case STATES.PAYMENT_MONTHLY:
                case STATES.EXTRAFEE:
                case STATES.EXTRAFEE_PAYMENT_RESULT:
                case STATES.EXTRAFEE_PAYMENT_SINOPACATM:
                case STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD:
                case STATES.EXTRAFEE_PAYMENT_POINT:
                case STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE:
                case STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS:
                case STATES.EXTRAFEE_PAYMENT_MONTHLY:
                case STATES.MAIL_IDENTIFY:
                case STATES.RESET_PASSWORD:
                case STATES.RESET_BUSINESS_MEMBER_PASSWORD:
                case STATES.CHANGE_EMAIL:
                case STATES.ACTIVITY_CHECK:
                case STATES.ACTIVITY_CHECK_WITH_DATE:
                case STATES.REGISTER_SUCCESS:
                case STATES.ENTERPRISE_SIGNUP:
                case STATES.SIGNUP:
                case STATES.MEMBER_SIGNUP:
                // case STATES.SPECIAL_OFFER:
                case STATES.POINTS_MONTHLY_INTRODUCTION:
                case STATES.POINTS_INTRODUCTION:
                case STATES.BUSINESSMEMBER_MAIL_IDENTIFY:
                case STATES.ABOUT:
                    return true;
                default:
                    return false;
            }
        }

        var init = function() {

        }

		//==========================
        //  Events
        //==========================
        $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $rootScope.state = $state.current.name;

            if(fromState) {
                $rootScope.historyState.unshift({
                    name: fromState.name,
                    params: fromParams,
                });
            }

            document.body.scrollTop = document.documentElement.scrollTop = 0;

            if(toState.name) {
                var href = $state.href(toState.name, toParams);
                $InifECGA.pageTrack(href);
            }

            $WebTitle.changeWebTitle($state.current.name);
        });

        //==========================
        //  Members
        //==========================
        $rootScope.state = $state.current.name;
        $rootScope.historyState = [];

        //==========================
        //  Methods
        //==========================
        $scope.isHomeView = isHomeView;
        $scope.isAllPdtView = isAllPdtView;
        $scope.isProductView = isProductView;
        $scope.isCartView = isCartView;
        $scope.isPaymentView = isPaymentView;
        $scope.isMemberView = isMemberView;
        $scope.isFaqView = isFaqView;
        $scope.isSearchView = isSearchView;
        $scope.isBlogView = isBlogView;
        $scope.isResourceView = isResourceView;
        $scope.isDesignView = isDesignView;
        $scope.isOtherView = isOtherView;

        //==========================
        //  Init
        //==========================

        init();
	}
])

// .directive("spinn", function() {
//     return {
//         restrict: "E",
//         template: '<i class="zmdi zmdi-spinner zmdi-hc-spin"></i>',
//     }
// })

.directive('spin',  ['$timeout', function($timeout){
  return {
        restrict: 'E',
        template: '<div class="spin" style="width: {{size}}; height: {{size}}; border-right-color: {{color}}; border-bottom-color: {{color}};"></div>',
        scope: {
            size: "@spinSize",
            color: "@spinColor"
        },
        link: function(scope, element, attrs, ctrls) {

            scope.size = '16px';
            scope.color = '#fff';
        }
    };
}])

.directive('inputSelectAll', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs, ctrls) {
            $(element).on('click', function() {
                $(this).select();
            });
        }
    };
});

// 明確發布 main AngularJS app 給 downstream scripts 註冊使用。
// 理由同上：bundler 的 module scope 下，downstream 檔案看不到本檔的裸 app 變數。
window.InifECApp = app;
